import MuiChip from '@mui/material/Chip';
import { InfoBadgeProps } from './interface';
import React from 'react';
import { palette } from '@src/theme';

export const InfoBadge = ({ color, label }: InfoBadgeProps) => {
  let bgColor = palette.controls['backing+line'];
  let textColor = palette.text.secondary;
  switch (color) {
    case 'info':
      textColor = palette.state.info.secondary;
      bgColor = palette.state.info['backing-1'];
      break;
    case 'error':
      textColor = palette.state.error.secondary;
      bgColor = palette.state.error['backing-1'];
      break;
    case 'warning':
      textColor = palette.state.warning.secondary;
      bgColor = palette.state.warning['backing-1'];
      break;
    case 'success':
      textColor = palette.state.success.secondary;
      bgColor = palette.state.success['backing-1'];
      break;
  }
  return (
    <MuiChip
      sx={{
        borderRadius: '5px',
        bgcolor: bgColor,
        color: textColor,
        px: '8px',
        py: '4px',
        typography: {
          fontSize: '11px',
        },
      }}
      label={label}
    />
  );
};
